export const isColor = (color) => {
    if (/^(#[0-9a-f]{3,8}|(rgba?|hsla?|hwb|lab|lch)\(.+?\))$/i.test(color)) {
        return true;
    }
    if (/^[a-z]+$/.test(color)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=helper.js.map